import { BookmarkPresenter } from '@/presentation/presenters/bookmark/bookmarkPresenter'
import { BookmarkViewModel } from '@/presentation/viewmodels/bookmark/bookmarkViewModel'

export function useBookmarkPresenter(presenter: BookmarkPresenter = new BookmarkPresenter(new BookmarkViewModel())) {
  return {
    bookmark: presenter.bookmark,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getBookmark: presenter.getBookmark.bind(presenter),
    postBookmark: presenter.postBookmark.bind(presenter),
    deleteBookmark: presenter.deleteBookmark.bind(presenter)
  }
}
